import { Group, Text } from '@mantine/core';

import { IconFigmaInfo } from '@/assets/icons';

interface InfoBannerProps {
  message: string;
}

export const InfoBanner = ({ message }: InfoBannerProps) => (
  <Group
    gap={12}
    wrap="nowrap"
    align="flex-start"
    p={16}
    style={{
      borderRadius: 12,
      backgroundColor: 'var(--color-status-info-soft)',
      border: '1px solid var(--color-status-info)'
    }}
  >
    <IconFigmaInfo size={16} color="var(--color-status-info)" />
    <Text fz={12.5} style={{ color: 'var(--color-status-info)', lineHeight: 1.35 }}>
      {message}
    </Text>
  </Group>
);
